import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import moment from 'moment';
import 'lib-flexible';
import reportWebVitals from '@/reportWebVitals';
import history from '@tools/history';
import store from '@/store';
import App from '@/App';

// 引入css
import '@styles/reset.less';
import '@styles/global.less';
import 'antd-mobile/es/global/theme.css';
import 'swiper/swiper.less';

// 语言时区设置
moment.locale('zh-cn');

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
